export default __webpack_public_path__ + "static/media/conversations.57d6536e.svg";